import React from 'react';
import { Svg } from '../components/svg';

export const CrossSquareIcon = ({ width = '24', height = '24', fill = 'currentColor', ...props }) => (
  <Svg viewBox="0 0 496 496" {...props}>
    <path
      xmlns="http://www.w3.org/2000/svg"
      d="M8 488h480V8H8zm132.52-347.48L248 248l107.48-107.48L248 248l107.48 107.48L248 248 140.52 355.48 248 248zm0 0"
      fill="none"
      data-original="#ff6243"
    />
    <g xmlns="http://www.w3.org/2000/svg" fill={fill}>
      <path
        d="M134.863 361.137a8.004 8.004 0 0011.313 0L248 259.313l101.824 101.824a8 8 0 0011.313-11.313L259.312 248l101.825-101.824a8 8 0 10-11.313-11.313L248 236.687 146.176 134.863a8 8 0 10-11.313 11.313L236.687 248 134.863 349.824a8.004 8.004 0 000 11.313zm0 0"
        data-original="#231f20"
      />
      <path
        d="M496 488V8a8 8 0 00-8-8H8a8 8 0 00-8 8v480a8 8 0 008 8h480a8 8 0 008-8zm-16-8H16V16h464zm0 0"
        data-original="#231f20"
      />
    </g>
  </Svg>
);
